import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import ConditionalWrapper from '@/components/ui/custom/ConditionalWrapper';
import { Badge } from '@/components/ui/daisy';

type ShortcutCardProps = {
  icon: ReactNode;
  label: string;
  href?: string;
  count?: number;
  className?: string;
};

export default function ShortcutCard({
  icon,
  label,
  href,
  count,
  className,
}: ShortcutCardProps) {
  return (
    <ConditionalWrapper
      condition={!!href}
      wrapper={
        <Link
          to={href ?? ''}
          className="grid h-full w-full transition-[filter] hover:brightness-95"
        />
      }
    >
      <div
        className={twMerge(
          'flex h-full w-full flex-col gap-1 rounded-2xl p-4 text-base-content',
          className,
        )}
      >
        <span className="flex min-h-[2.125rem] items-start justify-between gap-2">
          {icon}
          <ConditionalRenderer condition={!!count}>
            <Badge
              size="xs"
              color="accent"
              className="size-4 rounded-full border-0 p-0 text-[0.5625rem] font-bold"
            >
              {count}
            </Badge>
          </ConditionalRenderer>
        </span>
        <span className="truncate text-sm leading-5">{label}</span>
      </div>
    </ConditionalWrapper>
  );
}
